import type { Solution } from '../types/database';

export const solutionsData: Solution[] = [
  {
    id: 'solution-parcours-1',
    type: 'Parcours',
    sucess:{
      title:'',
      subtitle:'',
    },
    failed:{
      title:'',
      subtitle:''
    },
    explicationCourte: 'Comprendre les daltonismes et leurs impacts',
    explicationDetaillee: 'Les troubles de la perception des couleurs affectent environ 8% des hommes et 0.5% des femmes. Cette solution explique comment adapter les interfaces pour être inclusives.',
    images: ['/img/solutions/daltonisme-exemple.png'],
    couvertures: ['/img/solutions/daltonisme-cover.png'],
    parcoursId: 'parcours-1'
  },
  {
    id: 'solution-mission-1-1',
    type: 'Mission',
    sucess:{
      title:'Bien jouer, tu as choisis le rouge !',
      subtitle:'Mais... ça ne serait pas un coup du hasard tout ça ?'
    },
    failed:{
      title:'Oups tu n’as pas choisis le rouge !',
      subtitle:''
    },
    explicationCourte: 'Et en même temps, pas facile de choisir le rouge quand tu ne le vois pas.',
    explicationDetaillee: 'Pour rendre l’information accessible à ceux qui ne voient pas les couleurs ou les voient différemment, il ne faut <strong>pas donner l’information que par la couleur.</strong>',
    images: ['/img/solutions/mission-1-1.png'],
    couvertures: ['/img/solutions/mission-1-1-cover.png'],
    missionId: 'mission-1-1'
  },
  {
    id: 'solution-mission-1-2',
    type: 'Mission',
    sucess:{
      title:'Bien jouer !',
      subtitle:'Mais... ça ne serait pas un coup du hasard tout ça ?',
    },
    failed:{
      title:'Oups pas tout à fait !',
      subtitle:''
    },
    explicationCourte: 'Et en même temps, pas facile de choisir la bonne couleur quand tout est gris.',
    explicationDetaillee: 'Pour rendre l’information accessible à ceux qui ne voient pas les couleurs ou les voient différemment, il ne faut <strong>pas donner l’information que par la couleur.</strong>',
    images: ['/img/solutions/mission-1-2.png'],
    couvertures: ['/img/solutions/mission-1-2-cover.png'],
    missionId: 'mission-1-2'
  },

  {
    id: 'solution-parcours-2',
    type: 'Parcours',
    sucess:{
      title:'',
      subtitle:'',
    },
    failed:{
      title:'',
      subtitle:''
    },
    explicationCourte: 'Comprendre les daltonismes et leurs impacts',
    explicationDetaillee: 'Les troubles de la perception des couleurs affectent environ 8% des hommes et 0.5% des femmes. Cette solution explique comment adapter les interfaces pour être inclusives.',
    images: ['/img/solutions/daltonisme-exemple.png'],
    couvertures: ['/img/solutions/daltonisme-cover.png'],
    parcoursId: 'parcours-2'
  },
  {
    id: 'solution-mission-2-1',
    type: 'Mission',
    sucess:{
      title:'Bien jouer mais c\était difficile non ?',
      subtitle:'',
    },
    failed:{
      title:'Tu as trouvé cette mission difficile ?',
      subtitle:''
    },
    explicationCourte: 'Et c’est normal, pas facile de lire un texte sans bien voir le contour des lettres.',
    explicationDetaillee: 'Pour permettre aux personnes qui voient flou de pouvoir lire et comprendre le contenu, il faut par exemple :',
    images: ['/img/solutions/mission-2-1.png'],
    couvertures: ['/img/solutions/mission-2-1-cover.png'],
    missionId: 'mission-2-1'
  },
  {
    id: 'solution-mission-2-2',
    type: 'Mission',
    sucess:{
      title:'Yeahh',
      subtitle:'',
    },
    failed:{
      title:'Oups pas tout à fait !',
      subtitle:''
    },
    explicationCourte: 'Soit tu n’as pas eu le temps de tout lire, soit tu n’a pas réussit à lire. Et c’est normal, moi aussi ça me pique les yeux ces ratios de contrastes.',
    explicationDetaillee: 'Pour rendre l’information lisible par tous, <strong>il faut que le premier plan et le second plan soient bien contrastés.</strong>',
    images: ['/img/solutions/mission-2-2.png'],
    couvertures: ['/img/solutions/mission-2-2-cover.png'],
    missionId: 'mission-2-2'
  },

  {
    id: 'solution-parcours-3',
    type: 'Parcours',
    sucess:{
      title:'',
      subtitle:'',
    },
    failed:{
      title:'',
      subtitle:''
    },
    explicationCourte: 'Comprendre les daltonismes et leurs impacts',
    explicationDetaillee: 'Les troubles de la perception des couleurs affectent environ 8% des hommes et 0.5% des femmes. Cette solution explique comment adapter les interfaces pour être inclusives.',
    images: ['/img/solutions/daltonisme-exemple.png'],
    couvertures: ['/img/solutions/daltonisme-cover.png'],
    parcoursId: 'parcours-3'
  },
  {
    id: 'solution-mission-3-1',
    type: 'Mission',
    sucess:{
      title:'Bien jouer Andy',
      subtitle:'Combien de clic à côté avant d’y arriver ?',
    },
    failed:{
      title:'Tu as trouvé cette mission difficile ?',
      subtitle:''
    },
    explicationCourte: '',
    explicationDetaillee: 'Pour aider les personnes ayant des troubles de la mobilité (tremblement, difficultés de précisions...), <b>il faut s’assurer que les objets interactifs (boutons, barre de scroll...) ne sont pas trop petits.</b>',
    images: ['/img/solutions/mission-3-1.png'],
    couvertures: ['/img/solutions/mission-3-1-cover.png'],
    missionId: 'mission-3-1'
  },

  {
    id: 'solution-parcours-4',
    type: 'Parcours',
    sucess:{
      title:'',
      subtitle:'',
    },
    failed:{
      title:'',
      subtitle:''
    },
    explicationCourte: 'Comprendre les daltonismes et leurs impacts',
    explicationDetaillee: 'Les troubles de la perception des couleurs affectent environ 8% des hommes et 0.5% des femmes. Cette solution explique comment adapter les interfaces pour être inclusives.',
    images: ['/img/solutions/daltonisme-exemple.png'],
    couvertures: ['/img/solutions/daltonisme-cover.png'],
    parcoursId: 'parcours-4'
  },
  {
    id: 'solution-mission-4-1',
    type: 'Mission',
    sucess:{
      title:'Bien jouer Andy',
      subtitle:'Combien de clic à côté avant d’y arriver ?',
    },
    failed:{
      title:'Tu as trouvé cette mission difficile ?',
      subtitle:''
    },
    explicationCourte: '<strong>Perso je n’ai pas réussi la première fois (ni la deuxième d’ailleurs) !</strong>',
    explicationDetaillee: 'Pour aider les personnes ayant des troubles de la mémoire ou de l’attention, <strong>il vaut mieux limiter les sources de distractions et ne pas imposer de limite de temps dans les démarches.</strong>\n\n<strong>Si la limite de temps est vraiment nécessaire,</strong> il faut permettre à l’utilisateur de la prolonger.',
    images: ['/img/solutions/mission-4-1.png'],
    couvertures: [],
    missionId: 'mission-4-1'
  },

  {
    id: 'solution-parcours-5',
    type: 'Parcours',
    sucess:{
      title:'',
      subtitle:'',
    },
    failed:{
      title:'',
      subtitle:''
    },
    explicationCourte: 'Comprendre les daltonismes et leurs impacts',
    explicationDetaillee: 'Les troubles de la perception des couleurs affectent environ 8% des hommes et 0.5% des femmes. Cette solution explique comment adapter les interfaces pour être inclusives.',
    images: ['/img/solutions/daltonisme-exemple.png'],
    couvertures: ['/img/solutions/daltonisme-cover.png'],
    parcoursId: 'parcours-5'
  },
  {
    id: 'solution-mission-5-1',
    type: 'Mission',
    sucess:{
      title:'Bien jouer Andy !',
      subtitle:'Pas facile n’est-ce pas de déchiffrer ce texte en un temps réduit ?',
    },
    failed:{
      title:'C’était cinq !',
      subtitle:'Pas facile n’est-ce pas de déchiffrer ce texte en un temps réduit ?'
    },
    explicationCourte: 'Les personnes atteintes de dyslexie ont des <strong>difficultés pour lire des texte de par leur difficultés à identifier certaines lettres et mots.</strong>\n\nMais on peut les aider !',
    explicationDetaillee: '\n-Évite de choisir des <strong>typographies trop grasses</strong>\n-Évite de choisir des <strong>typographies où les lettre b d p q sont identiques</strong>\n-<strong>Aligne le texte à gauche</strong> et <strong>évite la justification</strong>\n\nN’impose <strong>pas de limite de temps</strong> ou permet à ton utilisateur de l’augmenter !',
    images: ['/img/solutions/mission-5-1.png'],
    couvertures: ['/img/solutions/mission-5-1-cover.png'],
    missionId: 'mission-5-1'
  },
];